// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as AddComponent} from './Add.svg';

import Icon, { TIconProps } from '../Icon';

export const IconAdd = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <AddComponent/>
  </Icon>
));
